import React from 'react';
import {
    Box,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    Text,
    Heading,
    ModalCloseButton,
    useDisclosure,
    Button,
    Center
} from '@chakra-ui/react'
import VolunteerForm from './VolunteerForm';

export default function ContactModal(props) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [scrollBehavior, setScrollBehavior] = React.useState('inside');
  
    return (
      <>
        <Box onClick={onOpen} cursor="pointer" mb="4" textAlign="center">
          <Center>
                <Button size="lg" textAlign="center" variant="Blue">
                    Volunteer
                </Button>
          </Center>
        </Box>
  
        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={scrollBehavior} size="xl" preserveScrollBarGap>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader p="8">
              <Heading as="h5" fontWeight="800">{props.directorName}</Heading>
                <Text fontWeight='bold' mb="0" fontSize="1.25rem">
                    Contact Us To Volunteer
                </Text>
            </ModalHeader>
            <ModalCloseButton m="4"/>
            <ModalBody>
              
              <VolunteerForm />
              
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    )
  }